export default {
    fields: {
        name: {
            label: 'Ime i prezime',
            placeholder: 'Unesite ime i prezime',
        },
        email: {
            label: 'Email',
            placeholder: 'Unesite email',
        },
        phone: {
            label: 'Telefon',
            placeholder: 'Unesite broj telefona',
        },
        company: {
            label: 'Kompanija',
            placeholder: 'Unesite kompaniju',
        },
        description: {
            label: 'Poruka',
            placeholder: 'Unesite poruku',
        },
        title: {
            label: 'Naziv',
            placeholder: 'Unesite naziv',
        },
    },
    buttons: {
        send: 'Pošalji',
    },
    success: {
        message: 'Vaše pitanje je proslijeđeno. Uskoro ćete dobiti odgovor na email!',
    },
}
